import React, { useState, useEffect } from 'react';
import ProfileCard from '../../components/profile-card/profile-card';
import Transactions from '../../containers/transactions/transactions';
import Header from '../../components/header/header';
import AppRoutes from '../../constants/AppRoutes';
import AuthenticationService from '../../services/authentication-service';
import Constants from '../../constants/Constants';
import Messages from '../../constants/Messages';

const Profile = () => {
    const [userRole, setUserRole] = useState('');
    const [vendorId, setVendorId] = useState(null);
    const [balanceValue, setBalanceValue] = useState(0);
    const [userCurrentLocation, setUserCurrentLocation] = useState();


    useEffect(() => {
        (async () => {
            const userDetails = await AuthenticationService.getUserDetails();
            let eventDetails = await AuthenticationService.getEventDetails();
            let userSelectedLocation = eventDetails ? eventDetails?.user?.selectedLocation : undefined;
            setUserCurrentLocation(userSelectedLocation);
            if (userDetails) {
                setUserRole(userDetails.userRole);
                if(userDetails.vendorId) {
                    setVendorId(userDetails.vendorId);
                }
            }
        })();
    }, []);

    return (
        <div className='bg-gray-100'>
            {
                userRole ? (
                    <div className='min-h-screen'>
                        {
                            userRole === Constants.USER_ROLES.EMPLOYEE ? (
                                <Header isPrevActive={true} prevNavigationText={Messages.SHOP.TITLE} prevPath={AppRoutes.HOME} />
                            ) : <Header />
                        }
                        <div className='mx-auto max-w-lg mt-4 pb-20'>
                            <ProfileCard balanceValue={balanceValue} userCurrentLocation={userCurrentLocation} isProfilePage={true}/>
                            <Transactions vendorId = {vendorId} userRole = {userRole}/>
                        </div>
                    </div>
                ) : null
            }
        </div>

    )
}

export default Profile;





